import { render, staticRenderFns } from "./CreateAndUpdate.vue?vue&type=template&id=8b4e33cc&scoped=true"
import script from "./CreateAndUpdate.vue?vue&type=script&lang=js"
export * from "./CreateAndUpdate.vue?vue&type=script&lang=js"
import style0 from "./CreateAndUpdate.vue?vue&type=style&index=0&id=8b4e33cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4e33cc",
  null
  
)

export default component.exports